import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { madeJustNow } from '../../utils/lastTool';
import { sentSteps, signInSource, signupStep } from '../../utils/signupSteps';

// Set at the first signed-in moment of a visit: a page loaded signed in later in the visit is not a new sign-in
const SEEN = 'signup.steps.signedIn';

function seenBefore() {
  try {
    if (window.sessionStorage.getItem(SEEN)) return true;
    window.sessionStorage.setItem(SEEN, '1');
  } catch {
    // storage refused: count it (once a visit by signupStep anyway)
  }
  return false;
}

/**
 * Mounted app-wide (App.tsx): counts a sign-in that finished by Google One Tap or Google's page, new account or
 * returning (utils/signupSteps.js). Every page mounts One Tap only while the visitor is signed out, so the moment
 * it signs someone in it is gone; only something mounted everywhere sees it happen.
 */
export default function SignInSteps() {
  const { isLoaded, isSignedIn, user } = useUser();
  const { pathname } = useLocation();
  const was = useRef(null);
  useEffect(() => {
    if (!isLoaded) return;
    const before = was.current;
    was.current = Boolean(isSignedIn);
    if (!isSignedIn || before === true || seenBefore()) return;
    const source = signInSource({ sent: sentSteps(), pathname, atLoad: before === null });
    if (source) signupStep(`${source}_${madeJustNow(user?.createdAt) ? 'new' : 'returning'}`);
  }, [isLoaded, isSignedIn]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
